import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { shopApi } from "./api";
import { useCustomerAuth } from "./AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function ShopAuthCallback({ redirectTo = "/checkout" }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useCustomerAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate(redirectTo, { replace: true });
      return;
    }
    shopApi
      .post("/auth/session", { session_id: sessionId })
      .then((r) => {
        setUser(r.data);
        window.history.replaceState({}, "", window.location.pathname);
        navigate(redirectTo, { replace: true, state: { user: r.data } });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error("Google session exchange failed:", err?.response?.status, err?.response?.data || err?.message);
        window.history.replaceState({}, "", window.location.pathname);
        navigate(redirectTo, { replace: true });
      });
  }, []);

  return (
    <main
      className="min-h-screen flex items-center justify-center bg-[var(--gx-bg)] text-dim text-sm"
      data-testid="shop-auth-callback"
    >
      Signing you in…
    </main>
  );
}
